import { render } from "./inbox-list.vue?vue&type=template&id=66d89ed0"
import script from "./inbox-list.vue?vue&type=script&lang=js"
export * from "./inbox-list.vue?vue&type=script&lang=js"

import "./inbox-list.vue?vue&type=style&index=0&id=66d89ed0&lang=scss"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__